import type {
  ExhibitionPresetSuggestionDto,
  StartExhibitionSessionDto,
  StartExhibitionSessionResponse,
} from '@paladin-monorepo/common';
import API from '../api';

export const exhibitionApi = {
  async getPresetSuggestion(): Promise<ExhibitionPresetSuggestionDto> {
    return API.get<ExhibitionPresetSuggestionDto>('/exhibition/preset-suggestion').then(
      (res) => res.data,
    );
  },

  async startSession(body: StartExhibitionSessionDto): Promise<StartExhibitionSessionResponse> {
    return API.post<StartExhibitionSessionResponse>('/exhibition/sessions', body).then(
      (res) => res.data,
    );
  },
};
